<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$consts.shopName()]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <!-- 搜索行 -->
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="shopKeyword"
              v-model="shopOptions.keyword"
              @text="shopKeyword = $event"
              :label="$t('Shop.shopsKeyword', [$consts.shopName()])"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
          </v-row>
        </v-col>
      </v-row>
      <!-- 高级搜素行 -->
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="loginUserId"
                  v-model="shopOptions.login_user_id"
                  @text="loginUserId = $event"
                  :label="$t('AccountAdsShop.shopUserKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrict v-model="districtSelected" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- 表格 -->
      <v-data-table
        :headers="headers"
        :items="shops"
        :loading="loading"
        :options.sync="shopOptions"
        :page.sync="paging.page"
        :server-items-length="paging.count"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.action="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-btn
              color="primary"
              dense
              @click="
                $emit('confirm', item);
                dialog = false;
              "
            >
              {{ $t("Shop.Fields.choose") }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-chip small label>
              <!-- :color="item.status | shopStatusColor"
              :text-color="item.status | shopStatusTextColor" -->
              {{ item.status | shopStatusText }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.abandon") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Shops from "@/api/shops";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";

const defaultShopOptions = {
  keyword: "",
  district_id: "",
  login_user_id: ""
}

export default {
  name: "DialogShop",

  components: {
    SearcherKeyword,
    SearcherDistrict,
  },

  props: {
    value: Boolean,
    isActivity: Boolean,
    isNotPsi: Boolean,
  },
  mounted() {
    this.getShopsFromAPI();
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_district"),
          align: "start",
          sortable: false,
          value: "district.name",
        },
        {
          text: i18n.t("Shop.Fields.template"),
          align: "start",
          sortable: false,
          value: "template_name",
        },
        {
          text: i18n.t("Shop.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Shop.Fields.action"),
          align: "start",
          sortable: false,
          value: "action",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    filter: "",
    shops: [],
    shopOptions: {},
    paging: {},
    itemsPerPageOptions: 5,
    loginUserId: "",
    districtSelected: null,
    shopKeyword: "",
    districtID: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.resetSearch();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    districtSelected: {
      handler() {
        if (this.districtSelected) {
          this.shopOptions.district_id = this.districtSelected.id;
        } else {
          this.shopOptions.district_id = null;
        }
        this.getShopsFromAPI();
      },
    },
    shopOptions: {
      deep: true,
      handler() {
        this.getShopsFromAPI()
      }
    }
  },

  methods: {
    // resizeHeader() {
    //   this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    // },

    getShopsFromAPI() {
      this.shopsLoading = true;
      let options = {};
      if (this.isActivity) {
        options = Object.assign({}, this.shopOptions, {
          status: [1]
        });
      }
      if (this.isNotPsi) {
        options = Object.assign({}, this.shopOptions, {
          psi_enable: [0]
        });
      }

      Shops.fetchFiveForSelect(options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shops = response.data.shops;
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.shopOptions.page = 1;
            }
            this.shopsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.shopsLoading = false;
          }.bind(this)
        );
    },
    onSearch() {
      this.shopOptions = Object.assign({}, this.shopOptions, {
        keyword: this.shopKeyword,
        login_user_id: this.loginUserId,
      });
    },
    resetSearch() {
      this.districtSelected = null;
      this.shopOptions = JSON.parse(JSON.stringify(defaultShopOptions));
      [this.$refs.shopKeyword,this.$refs.loginUserId,].forEach((k) => {
        if (k) k.clear();
      });
    },
  },
};
</script>
